import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { AdditionalFormLayout } from "../../common/Layouts";
import data from "../../../assets/apiRoutes.json";
//import { AdditionalForm } from "../Lookups";
function AdditionalTab(props) {
    const { AdditionalForm } = props;

    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});


    const AdditionalFormLoad = useCallback(() => {
        AdditionalForm(formRefs);
    }, []);

    const handleFieldChange = useCallback((name, value, e) => {

    }, []);

    const handleSelectionChange = useCallback((name, e) => {
    }, []);

    return (
        <div className="FormMt">
        <FormField
            currrentUser={currentUser}
            layoutId='F1E9B642-BF91-4089-8C45-E8C98FB88B5F'
            layoutName='MyTestForm'
            defaultFormSchema={AdditionalFormLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
            onFormLoad={AdditionalFormLoad}
            noSpacingBeforeFirstRow={true}
        />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AdditionalTab);